import React from "react";

interface IProps {
  regularPrice: number;
  salePrice: number;
  isDetail?: boolean;
  detailsUI?: boolean;
}

const HowManytDealOFF = ({ regularPrice, salePrice, isDetail = false, detailsUI = false }: IProps) => {
  let reg = regularPrice ? Number(regularPrice) : 0;
  let sale = salePrice ? Number(salePrice) : 0;
  const discount = reg === 0 ? 0 : ((reg - sale) / reg) * 100;
  const discountPercentage = detailsUI ? discount.toFixed(2) : discount.toFixed(1);

  if(discount === 0 || sale === 0) {
    return <div></div>;
  }

  if (isDetail) {
    return (
      <div className="bg-sticker-image p-1 flex items-center justify-center gap-2 w-[30px] 2xl:w-[40px]">
        <span className="text-white font-size-12px font-Lexend-Regular">
          {discountPercentage}% <br /> OFF
        </span>
      </div>
    );
  }

  if(detailsUI) {
    return (
      <span className="bg-[#FFE4E4] absolute top-3 left-3 2xl:py-2 py-1 2xl:px-4 px-3 text-[#EF4444] rounded-[50px] font-size-15px font-Lexend-Regular">
        {discountPercentage}% Off
      </span>
    );
  }

  return (
    <div className="bg-sticker-image p-1 flex items-center justify-center gap-2 w-[30px] 2xl:w-[40px] aspect-[1/1.3]">
      <span className="text-white font-size-12px font-Lexend-Regular">
        {discountPercentage}% <br /> OFF
      </span>
    </div>
  );
};

export default HowManytDealOFF;